import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FiUser, FiLock, FiEye, FiEyeOff } from 'react-icons/fi';
import { useAuth } from '../contexts/AuthContext';
import './Auth.css';
import logo from './logo_efc.svg';

const Login = () => {
  const [formData, setFormData] = useState({
    emailOrUsername: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const result = await login(formData.emailOrUsername, formData.password);

    if (result.success) {
      navigate('/');
    }

    setLoading(false);
  };

  return (
    <div className="auth-container">
      <div className="container">
        <div className="auth-form">
          <div className="auth-header">
            <img src={logo} alt="EFC Buseck" className="auth-logo" />
            <h2>Willkommen zurück</h2>
            <p className="auth-subtitle">Melde dich in deinem EFC-Buseck-Konto an</p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="emailOrUsername">E-Mail oder Benutzername</label>
              <div className="input-wrap">
                <FiUser className="input-icon" aria-hidden="true" />
                <input
                  type="text"
                  id="emailOrUsername"
                  name="emailOrUsername"
                  value={formData.emailOrUsername}
                  onChange={handleChange}
                  required
                  autoComplete="username"
                  placeholder="deine.email@beispiel.de"
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="password">Passwort</label>
              <div className="input-wrap has-toggle">
                <FiLock className="input-icon" aria-hidden="true" />
                <input
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  autoComplete="current-password"
                  placeholder="Dein Passwort"
                />
                <button
                  type="button"
                  className="pw-toggle"
                  onClick={() => setShowPassword((v) => !v)}
                  aria-label={showPassword ? 'Passwort verbergen' : 'Passwort anzeigen'}
                >
                  {showPassword ? <FiEyeOff /> : <FiEye />}
                </button>
              </div>
            </div>

            <div className="auth-forgot">
              <Link to="/passwort-vergessen">Passwort vergessen?</Link>
            </div>

            <button type="submit" className="btn btn-primary auth-submit" disabled={loading}>
              {loading ? 'Wird angemeldet …' : 'Anmelden'}
            </button>
          </form>

          <div className="auth-links">
            <p>
              Noch kein Account?{' '}
              <Link to="/registrieren">Jetzt registrieren</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
